import { useEffect, useState } from 'react';
import { scrollTop } from '@/helpers/utils';
import { useGetStreakActivity } from '@/query/queries/streak/useGetStreakActivity';
import { Pagination } from '@/components/Pagination';
import { Table } from './Table';

export const ActivityDesktop = () => {
  const [page, setPage] = useState(1);
  const { data, isLoading } = useGetStreakActivity({ page });

  useEffect(() => {
    scrollTop();
  }, [page]);

  return (
    <>
      <Table isLoading={isLoading} data={data} />
      {data?.total_pages > 0 && (
        <Pagination
          currentPage={page - 1}
          totalPages={data?.total_pages}
          onPageChange={({ selected }) => setPage(selected + 1)}
        />
      )}
    </>
  );
};
